import type { Field } from './types';
import { fitSelectionRule, VALIDATION_OPS, validationShape } from './questionSettings';

export function defaultLabels(values: string[] | undefined, name: string): string[] {
  const entries = values?.length ? values : [''];
  const used = new Set(entries.filter(value => typeof value === 'string' && value.trim()).map(value => value.trim().toLowerCase()));
  return entries.map((value, index) => {
    if (typeof value !== 'string' || value.trim()) return value;
    let number = index + 1;
    while (used.has(`${name} ${number}`.toLowerCase())) number++;
    const label = `${name} ${number}`; used.add(label.toLowerCase()); return label;
  });
}

/** Resolve empty editor controls without changing the organizer's unfinished draft. */
export function questionDefaults(field: Field): Field {
  if (!field || typeof field !== 'object') return field;
  const next = { ...field };
  if (typeof next.label === 'string' && !next.label.trim()) {
    next.label = next.type === 'section' ? 'Untitled section' : next.type === 'title_text' ? 'Untitled title' : 'Untitled question';
    next.labelFormat = undefined;
  }
  if (['choice', 'checkboxes', 'dropdown'].includes(next.type) && (next.options === undefined || Array.isArray(next.options))) next.options = defaultLabels(next.options, 'Option');
  if (['choice_grid', 'checkbox_grid'].includes(next.type)) {
    if (!next.grid || ((next.grid.rows === undefined || Array.isArray(next.grid.rows)) && (next.grid.columns === undefined || Array.isArray(next.grid.columns)))) next.grid = { ...next.grid, rows: defaultLabels(next.grid?.rows, 'Row'), columns: defaultLabels(next.grid?.columns, 'Column') };
  }
  if (next.type === 'linear_scale') next.scale = { min: 1, max: 5, ...next.scale };
  if (next.type === 'rating') next.rating = { max: 5, ...next.rating };
  if (next.type === 'acknowledgment' && (typeof next.acknowledgmentLabel === 'string' && !next.acknowledgmentLabel.trim())) next.acknowledgmentLabel = 'I agree';
  if (!next.validation && next.validationEnabled) next.validationEnabled = false;
  else if (next.validation && validationShape(next.validation)) {
    const rule = next.validation;
    const args = VALIDATION_OPS[rule.kind].find(operation => operation.op === rule.op)!.args;
    if ((args >= 1 && !String(rule.value).trim()) || (args === 2 && (rule.value2 === undefined || !String(rule.value2).trim()))) next.validationEnabled = false;
  }
  return fitSelectionRule(next);
}
